import { useState } from 'react';
import { DownloadState } from '../interfaces/DownloadState';
import downloadAndOpenFile from '../utils/downloadAndOpenFile';

function useDownload(url: string, filename: string, mime: 'application/pdf' | 'application/octet-stream' = 'application/pdf'): [DownloadState, () => void] {
  const [downloadState, setDownloadState] = useState<DownloadState>('ready');

  function download() {
    setDownloadState('downloading');
    const callback = (success: boolean) => {
      setDownloadState(success ? 'done' : 'failed');
      setTimeout(() => {
        setDownloadState('ready');
      }, 4000);
    };
    downloadAndOpenFile(url, filename, mime, callback);
  }

  return [downloadState, download];
}

/**
 * @deprecated useDownload has been deprecated. Please use secured links instead.
 */
export default useDownload;
